<template>
    <section class="panel-body">
        <br>
        <router-link to="/index" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData()" class="btn btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active"> <i class="fa fa-tag"></i>
                                Experimente Grátis</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Tab panes -->
            <div class="card-body">
                <div class="tab-pane active" id="tabFormulario">
                    <register-company ref="TabCompany" :dados="dados"></register-company>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import RegisterCompany from '../home/components/register-company.vue';
    export default {
        components: {
            RegisterCompany
        },
        data() {
            return {
                loading: false,
                dados: {
                    adicionais: [],
                    loaded: true,
                    loading: false,
                    request: {},
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        initialSlide: 0,
                        centerPadding: "20px",
                        responsive: [{
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    infinite: true,
                                    dots: true,
                                },
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    initialSlide: 2,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    },
                    selected: {
                        fk_plano_id: null,
                        fk_validade_id: "",
                        planoValor: 0,
                        cardName: "",
                        cardNumber: "",
                        cardMonth: null,
                        cardYear: null,
                        cardCvv: "",
                        grecaptcha: "",
                        documento: "",
                        fantasia: "",
                        cep: "",
                        endereco: "",
                        numero: "",
                        bairro: "",
                        cidade: null,
                        estado: null,
                        pais: "1058",
                        complemento: "",
                        adicionais: [],
                    },
                },
            }
        },
        beforeMount() {
            if (this.auth_user.ambiente !== 'S') {
                this.$router.push('index');
            }
        },
        methods: {
            saveData() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$store.dispatch('experimentarGratis', this.dados.selected).then(response => {
                            this.loading = false;
                            toastr({
                                icon: response.status,
                                title: response.message
                            });
                            this.$store.dispatch('getUserData');
                            this.$router.push('/index');
                        });
                    }
                });
            },
        }
    }
</script>